import '../src/Assets/Style/style.css';
import AppRoute from './AppRoutes/AppRoute';


function App() {
  return (
    <div className="App">
     <AppRoute/>
    </div>
  );
}

export default App;
